import { Pipe, PipeTransform } from '@angular/core';
import { Item } from '../../order/interface/item';

/**
 * Formatiert die übergebene Nummer in einen lokalisierten String zur Wiedergabe im Frontend
 */
@Pipe({ name: 'nbItem' })
export class NbItemPipe implements PipeTransform {
  transform(item: Item): string {
    const productName = item.Product.Name;
    const quantity = item.Quantity;
    const displayNumber = item.Product.IdDisplay;
    
    return `${quantity} x ${productName} (${displayNumber})`;
  }
}